/**
 * Helper function to extract error message from API response.
 * Handles the JSend response format used by the account API.
 * It now accepts the i18next `t` function to translate error codes.
 *
 * @param {Error} error The error object, likely from axios.
 * @param {Function} t The i18next translation function.
 * @returns {string} A user-friendly, translated error message.
 */
export const extractErrorMessage = (error, t) => {
  if (error.response && error.response.data) {
    const { data } = error.response;
    const errorCode = data.code;

    // Try to translate the error code if it exists
    if (t && errorCode) {
      const translationKey = `errors.${errorCode}`;
      const translatedMessage = t(translationKey);
      // i18next returns the key if translation is not found
      if (translatedMessage !== translationKey) {
        return translatedMessage;
      }
    }

    // Fallback to existing message extraction
    if (data.status === "fail" && data.data) {
      // The message is nested in the `data` object for fail responses
      if (data.data.message) return data.data.message;
      if (typeof data.data === 'string') return data.data;
    }
    
    if (data.message) {
      return data.message;
    }
  }
  
  // Fallback to error message or a generic error message
  if (error.message) return error.message;

  return t ? t("errors.unknown") : "An unexpected error occurred.";
}; 